import _ from "lodash";
import {
  FETCHING_ACCOUNTS_REQUEST,
  FETCHING_ACCOUNTS_SUCCEEDED,
  FETCHING_ACCOUNTS_FAILED,
  FETCHING_ACCOUNT,
  FETCHING_ACCOUNT_SUCCEEDED,
  FETCHING_ACCOUNT_FAILED,
  UPDATING_ACCOUNT,
  UPDATING_ACCOUNT_SUCCEEDED,
  UPDATING_ACCOUNT_FAILED,
  UPDATING_ACCOUNT_SUBSCRIPTION,
  UPDATING_ACCOUNT_SUBSCRIPTION_SUCCEEDED,
  UPDATING_ACCOUNT_SUBSCRIPTION_FAILED,
  UPDATING_ACCOUNT_SETTINGS,
  UPDATING_ACCOUNT_SETTINGS_SUCCEEDED,
  UPDATING_ACCOUNT_SETTINGS_FAILED,
  UPDATING_SSO_CONFIGURATION,
  UPDATING_SSO_CONFIGURATION_SUCCEEDED,
  UPDATING_SSO_CONFIGURATION_FAILED,
  DELETING_ACCOUNT_REQUEST,
  DELETING_ACCOUNT_SUCCEEDED,
  DELETING_ACCOUNT_FAILED,
  FETCHING_ADMIN_APP_USERS_SUCCEEDED,
  FETCHING_ADMIN_APP_USERS,
  FETCHING_ADMIN_APP_USERS_FAILED,
  UPDATING_CONTACT_DETAILS,
  UPDATING_CONTACT_DETAILS_SUCCEEDED,
  UPDATING_CONTACT_DETAILS_FAILED,
  UPDATING_ONBOARDING_DETAILS,
  UPDATING_ONBOARDING_DETAILS_FAILED,
  UPDATING_ONBOARDING_DETAILS_SUCCEEDED,
  UPDATE_COLOR_PALETTE,
  UPDATE_COLOR_SUCCEEDED,
  UPDATE_COLOR_FAILED,
  SEEK_LIMIT,
  SEEK_LIMIT_SUCCEEDED,
  SEEK_LIMIT_FAILED,
  UPDATE_SUGGESTIONS,
  UPDATE_SUGGESTIONS_SUCCEEDED,
  UPDATE_SUGGESTIONS_FAILED,
  FETCHING_SUGGESTIONS,
  FETCHING_SUGGESTIONS_SUCCEEDED,
  FETCHING_SUGGESTIONS_FAILED,
  UPLOADING_ORDER_FORM,
  UPLOADING_ORDER_FORM_SUCCEEDED,
  UPLOADING_ORDER_FORM_FAILED,
  FETCHING_ORDER_FORMS_SUCCEEDED,
  INVALIDATE_ORDER_FORMS,
  FETCHING_ORDER_FORMS,
  DELETING_ORDER_FORM,
  DELETING_ORDER_FORM_FAILED,
  DELETING_ORDER_FORM_SUCCEEDED,
  FETCHING_SSO_CONFIGURATION,
  FETCHING_SSO_CONFIGURATION_SUCCEEDED,
  FETCHING_SSO_CONFIGURATION_FAILED,
  CHANGE_CURRENT_PRODUCT,
  UPDATE_CONTRACT_TERM,
  UPDATE_CONTRACT_TERM_SUCCEEDED,
  UPDATE_CONTRACT_TERM_FAILED,
  FETCHING_LICENCE_COUNT,
  FETCHING_LICENCE_COUNT_SUCCEEDED,
  FETCHING_LICENCE_COUNT_FAILED,
  UPDATE_LICENCE_COUNT,
  UPDATE_LICENCE_COUNT_SUCCEEDED,
  UPDATE_LICENCE_COUNT_FAILED,
  FETCH_SUBSCRIPTION_PLAN,
  FETCH_SUBSCRIPTION_PLAN_SUCCEEDED,
  FETCH_SUBSCRIPTION_PLAN_FAILED,
  FETCH_AVAILABLE_PLANS,
  FETCH_AVAILABLE_PLANS_SUCCEEDED,
  FETCH_AVAILABLE_PLANS_FAILED,
  UPDATING_SUBSCRIPTION_TYPE,
  UPDATING_SUBSCRIPTION_TYPE_SUCCEEDED,
  UPDATING_SUBSCRIPTION_TYPE_FAILED,
  UPLOAD_CUSTOM_FONT,
  UPLOADING_CUSTOM_FONT_SUCCEEDED,
  UPLOADING_CUSTOM_FONT_FAILED,
  FETCHING_ACCOUNT_INTEGRATIONS,
  FETCHING_ACCOUNT_INTEGRATIONS_SUCCEEDED,
  FETCHING_ACCOUNT_INTEGRATIONS_FAILED,
} from "../constants/actionTypes.jsx";

const initialState = {
    loading: false,
    summary: [], 
    pagination: {
        pageNumber: 0,
        totalPagesCount: 1,
        itemsPerPage: 20,
        totalItemCount: 0,
  },
  account: {
    name: "",
    url: "",
    industry: "",
  },
  fetchingAccount: {
    fetching: false,
    success: false,
    error: null,
  },
  updateAccount: {
    updating: false,
    success: false,
    error: null,
  },
  changeSubscription: {
    updating: false,
    success: false,
    error: null,
  },
  updateSettings: {
    updating: false,
    success: false,
    error: null,
  },
  deleteAccount: {
    deleting: false,
    success: false,
    error: null,
  },
  updatingCSM: {
    updating: false,
    success: false,
    error: null,
  },
  updatingOrderForm: {
    updating: false,
    success: false,
    error: null,
  },
  deletingOrderForm: {
    deleting: false,
    success: false,
    error: null,
  },
  orderForms: [],
  seekSubscription: {
    updating: false,
    success: false,
    error: null,
  },
  suggestionSubscription: {
    updating: false,
    success: false,
    error: null,
  },
  seekSuggestions: {
    updating: false,
    success: false,
    error: null,
  },
  seekSuggestionQuestions: [],
  SSO:{
    loginUrl: "",
    logoutUrl: "",
    certificate: "",
    domain: ""
  },
  updateSSO:{
    updating: false,
    success: false,
    error: null,
  },
  fetchingSSO:{
      fetching: false,
      success: false,
      error: null,
  },
  currentProduct:"paperflite",
  contractTerm:{
    updating: false,
    success: false,
    error: null,
  
  },
  licenceCount:{
    updating: false,
    success: false,
    error: null,
    count: null,
    fetching: false,
  },

  subscriptionPlan: {
    fetching: false,
    fetched: false,
    updating:false ,
    updated: false,
    error: null,
    items: [],
    count: null,
    plan: null,
    },

  uploadFont: {
    uploading: false,
    success: false,
    error: null,
  },
  integration: {
    loading: false,
    items: [],
    error: null,
    pagination: {
      currentPage: -1,
      totalPages: 1,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
  }
};


function accountsReducer(state = initialState, action) {
  switch (action.type) {
      case FETCHING_ACCOUNTS_REQUEST:
       return {
         ...state,
         loading: true,
       };

    case FETCHING_ACCOUNTS_SUCCEEDED: {
            const { summary, pagination } = action.payload.response;
            return {
                ...state,
                loading: false,
                summary: pagination.pageNumber === 0 ? summary : [...state.summary, ...summary],
                pagination: {
                    pageNumber: pagination.pageNumber,
                    totalPagesCount: pagination.totalPagesCount,
                    itemsPerPage: pagination.itemsPerPage,
                    totalItemCount: pagination.totalItemCount,
                },
            };
        }
    case CHANGE_CURRENT_PRODUCT:
      return Object.assign({}, state, {
        ...state,
        currentProduct: action.payload.productsvalue
      });
    case FETCHING_ACCOUNTS_FAILED:
      return Object.assign({}, state, {
        ...state,
        fetching: false,
        items: [],
        loading: false,
        pagination: {
          currentPage: -1,
          totalPages: 1,
          recordsPerPage: 20,
          totalRecordsCount: 0,
        },
      });
    case FETCHING_ACCOUNT:
      return Object.assign({}, state, {
        ...state,
        account: null,
        fetchingAccount: { fetching: true },
      });
    case FETCHING_ACCOUNT_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        account: { ...action.payload },
        fetchingAccount: { fetching: false, error: null },
      });
    case FETCHING_ACCOUNTS_FAILED: {
            return {
                ...state,
                loading: false,
                summary: [],
                pagination: {
                    pageNumber: 0,
                    totalPagesCount: 1,
                    itemsPerPage: 20,
                    totalItemCount: 0,
                },
            };
        }
    case FETCHING_ADMIN_APP_USERS:
      return Object.assign({}, state, {
        ...state,
        adminAppUsers: null,
        fetchingAdminUsers: { fetching: true },
      });

    case FETCHING_ADMIN_APP_USERS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        adminAppUsers: [...action.payload],
        fetchingAdminUsers: { fetching: false, error: null },
      });

    case FETCHING_ADMIN_APP_USERS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        adminAppUsers: null,
        fetchingAdminUsers: {
          fetching: false,
          error: error,
        },
      });
    }

    case UPDATING_CONTACT_DETAILS:
      return Object.assign({}, state, {
        ...state,
        updatingCSM: {
          updating: true,
          success: false,
          error: null,
        },
      });

    case UPDATING_CONTACT_DETAILS_SUCCEEDED: {
      const response = action.payload;
      return Object.assign({}, state, {
        ...state,
        account: {
          ...state.account,
          ...response
        },
        updatingCSM: {
          updating: false,
          success: true,
          error: null,
        },
      });
    }

    case UPDATING_CONTACT_DETAILS_FAILED:
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        updatingCSM: {
          updating: false,
          success: false,
          error: error,
        },
      });

    case UPDATING_ONBOARDING_DETAILS:
      return Object.assign({}, state, {
        ...state,
        updatingOnboarding: {
          updating: true,
          success: false,
          error: null,
        },
      });

    case UPDATING_ONBOARDING_DETAILS_FAILED:
      let onboardingError =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        updatingOnboarding: {
          updating: false,
          success: false,
          error: onboardingError,
        },
      });

    case UPDATING_ONBOARDING_DETAILS_SUCCEEDED: {
      const response = action.payload;
      return Object.assign({}, state, {
        ...state,
        account: {
          ...state.account,
          ...response
        },
        updatingOnboarding: {
          updating: false,
          success: true,
          error: null,
        },
      });
    }


    case UPDATING_ACCOUNT: {
      return Object.assign({}, state, {
        ...state,
        updateAccount: {
          updating: true,
        },
      });
    }

    case UPDATING_ACCOUNT_SUCCEEDED: {
      const response = action.payload
      return Object.assign({}, state, {
        ...state,
        account: {
          ...state.account,
          ...response
        },
        updateAccount: { updating: false, success: true, error: null },
      });
    }

    case UPDATING_ACCOUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        updateAccount: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case UPDATING_ACCOUNT_SUBSCRIPTION:
      return Object.assign({}, state, {
        ...state,
        changeSubscription: {
          updating: true,
        },
      });
    case UPDATING_ACCOUNT_SUBSCRIPTION_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        account: action.payload,
        changeSubscription: { updating: false, success: true, error: null },
      });
    case UPDATING_ACCOUNT_SUBSCRIPTION_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        changeSubscription: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case UPDATING_ACCOUNT_SETTINGS:
      return Object.assign({}, state, {
        ...state,
        updateSettings: {
          updating: true,
        },
      });
    case UPDATING_ACCOUNT_SETTINGS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        account: action.payload,
        updateSettings: { updating: false, success: true, error: null },
      });
    case UPDATING_ACCOUNT_SETTINGS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        updateSettings: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case UPDATING_SSO_CONFIGURATION:
      return Object.assign({}, state, {
        ...state,
        updateAccountSSO: {
          updating: true,
        },
      });
    case UPDATING_SSO_CONFIGURATION_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        account: action.payload,
        updateAccountSSO: { updating: false, success: true, error: null },
      });
    case UPDATING_SSO_CONFIGURATION_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        updateAccountSSO: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case DELETING_ACCOUNT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        deleteAccount: { deleting: true },
      });
    case DELETING_ACCOUNT_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        account: null,
        deleteAccount: {
          deleting: false,
          success: true,
          error: null,
        },
      });
    case DELETING_ACCOUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        deleteAccount: {
          deleting: false,
          success: false,
          error: error,
        },
      });
    }
    case UPDATE_COLOR_PALETTE: {
      return Object.assign({}, state, {
        ...state,
        updatingColor: {
          updating: true
        }

      });
    }
    case UPDATE_COLOR_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        account: action.payload,
        updatingColor: { updating: false, success: true, error: null },
      }
      );
    }
    case UPDATE_COLOR_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;
      return Object.assign({}, state, {
        ...state,
        updatingColor: {
          updating: false,
          success: false,
          error: error
        }
      });
    }

    case SEEK_LIMIT:
      return Object.assign({}, state, {
        ...state,
        seekSubscription: {
          updating: true,
        },
      });
    case SEEK_LIMIT_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        account: action.payload,
        seekSubscription: { updating: false, success: true, error: null },
      });
    case SEEK_LIMIT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        seekSubscription: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }
    case UPDATE_SUGGESTIONS:
      return Object.assign({}, state, {
        ...state,
        suggestionSubscription: {
          updating: true,

        },
        seekSuggestionQuestions: []
      });
    case UPDATE_SUGGESTIONS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        seekSuggestionQuestions: action.payload,
        suggestionSubscription: { updating: false, success: true, error: null },
      });
    case UPDATE_SUGGESTIONS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        suggestionSubscription: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }
    case FETCHING_SUGGESTIONS:
      return Object.assign({}, state, {
        ...state,
        seekSuggestionQuestions: [],
        seekSuggestions: { updating: true }
      });
    case FETCHING_SUGGESTIONS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        seekSuggestionQuestions: action.payload,
        seekSuggestions: { updating: false, success: true, error: null },
      });
    case FETCHING_SUGGESTIONS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        seekSuggestions: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case FETCHING_ORDER_FORMS:
      return Object.assign({}, state, {
        ...state,
        fetchingOrderForms: {
          fetching: true,
          success: false,
          error: null,
        },
      });


    case FETCHING_ORDER_FORMS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        orderForms: [...action.payload],
        fetchingOrderForms: {
          fetching: false,
          success: true,
          error: null,
        },
      });

    case UPLOADING_ORDER_FORM:
      return Object.assign({}, state, {
        ...state,
        updatingOrderForm: {
          updating: true,
          success: false,
          error: null,
        },
      });


    case UPLOADING_ORDER_FORM_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        updatingOrderForm: {
          updating: false,
          success: true,
          error: null,
        },
      });

    case UPLOADING_ORDER_FORM_FAILED:
      let fetchingOrderFormsError =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        fetchingOrderForms: {
          fetching: false,
          success: false,
          error: fetchingOrderFormsError,
        },
      });

    case INVALIDATE_ORDER_FORMS:
      return Object.assign({}, state, {
        ...state,
        orderForms: []
      });

    case DELETING_ORDER_FORM:
      return Object.assign({}, state, {
        ...state,
        deletingOrderForm: {
          deleting: true,
          success: false,
          error: null,
        },
      });


    case DELETING_ORDER_FORM_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        deletingOrderForm: {
          deleting: false,
          success: true,
          error: null,
        },
      });

    case DELETING_ORDER_FORM_FAILED:
      let deleteError =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        deletingOrderForm: {
          deleting: false,
          success: false,
          error: deleteError,
        },
      });
      case FETCHING_SSO_CONFIGURATION: {
        return Object.assign({}, state, {
          ...state,
          updateSSO: {
            updating: true,
          },
          fetchingSSO: { fetching: true },
        });
      }
  
      case FETCHING_SSO_CONFIGURATION_SUCCEEDED: {
        const response = action.payload
        return Object.assign({}, state, {
          ...state,
          SSO: {
            ...state.SSO,
            ...response
          },
          updateSSO: { updating: false, success: true, error: null },
          fetchingSSO: { fetching: false, error: null },
        });
      }
  
      case FETCHING_SSO_CONFIGURATION_FAILED: {
        let error =
          action.payload && action.payload.errors
            ? action.payload.errors[0].message
            : "Unknown error";
  
        return Object.assign({}, state, {
          ...state,
          updateSSO: {
            updating: false,
            success: false,
            error: error,
          },
          fetchingSSO: {
            fetching: false,
            error: error,
          },
        });
      }

    case UPDATE_CONTRACT_TERM:
      return Object.assign({}, state, {
        ...state,
        contractTerm: {
          updating: true,
        },
      });
    case UPDATE_CONTRACT_TERM_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        account: action.payload,
        contractTerm: { updating: false, success: true, error: null },
      });
    case UPDATE_CONTRACT_TERM_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        contractTerm: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case FETCHING_LICENCE_COUNT: {
      return Object.assign({}, state, {
        ...state,
        licenceCount: {
          licenceCount:0,
          fetching: true,
        
        },
      });
    }
    
    case FETCHING_LICENCE_COUNT_SUCCEEDED: {
      const response = action.payload
      return Object.assign({}, state, {
        ...state,
        licenceCount: {
          ...state.licenceCount,
          count: response.licence,
          starterLicence: response.starterLicence,
          fetching: false
        
          
        },
      });
    }
    
    case FETCHING_LICENCE_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";
    
      return Object.assign({}, state, {
        ...state,
        licenceCount: {
          ...state.licenceCount,
          error: error,
          fetching: false,
  

        },
      });
    }

    case FETCH_SUBSCRIPTION_PLAN: {
      return Object.assign({}, state, {
        ...state,
        subscriptionPlan: {
          ...state.subscriptionPlan,
          fetching: true,
          error: null,
        },

      });
    }
    
    case FETCH_SUBSCRIPTION_PLAN_SUCCEEDED: {
      const response = action.payload
      return Object.assign({}, state, {
        ...state,
        subscriptionPlan: {
          ...state.subscriptionPlan,
          fetching: false,
          licenceError: null,
          starterLicenceError : null,
          plan: response.name,
          key: response.key
        },
    
      });
    }
    
    case FETCH_SUBSCRIPTION_PLAN_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";
    
      return Object.assign({}, state, {
        ...state,
        subscriptionPlan: {
          ...state.subscriptionPlan,
          fetching: false,
          error: error,
        },

      });
    }

    case FETCH_AVAILABLE_PLANS:
      return {
        ...state,
        subscriptionPlan: {
          ...state.subscriptionPlan,
          fetching: true,
          error: null,
        },
      };
    
    case FETCH_AVAILABLE_PLANS_SUCCEEDED: {
      const response = action.payload;
      return Object.assign({}, state, {
        ...state,
        subscriptionPlan: {    
          ...state.subscriptionPlan,
          fetching:false,
          fetched:true,
          error: null,
          items: response
        },
      });
    }

    case FETCH_AVAILABLE_PLANS_FAILED:
       let errors =  action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return {
        ...state,
        subscriptionPlan: {
          ...state.subscriptionPlan,
          error: errors,
          fetching:false,
          fetched:true,
        },
      };

    case UPDATING_SUBSCRIPTION_TYPE:
      return Object.assign({}, state, {
        ...state,
        subscriptionPlan: {
          ...state.subscriptionPlan,

          updated: false,
          error:null,
          starterLicenceError: null,
          updating:true,
        },
        licenceCount: {
          ... state.licenceCount,
          update: true,
          error: "",
          starterLicenceError: null,
        }
        
      });
    case UPDATING_SUBSCRIPTION_TYPE_SUCCEEDED:
      const licenceCount = action.payload;
      return Object.assign({}, state, {
        ...state,
        subscriptionPlan: { 
          ...state.subscriptionPlan,
           updated: true,
           error: null,
           starterLicenceError: null,
           updating:false,
          },

        licenceCount: {
          ...state.licenceCount,
          success: true,
          count: licenceCount,
          updating: false,
        },
      });

      case UPDATING_SUBSCRIPTION_TYPE_FAILED: {
        const error = _.get(action, 'payload.errors[0]', { code: 0, message: "Unknown Error" });
        const licenceError = error.code !== 20020 ? error.message : null;
        const starterLicenceError = error.code === 20020 ? error.message : null;

      
        return Object.assign({}, state, {
          ...state,
          subscriptionPlan: {
            ...state.subscriptionPlan,
            updated: false,
            error: licenceError,
            starterLicenceError: starterLicenceError,
            updating:false,
          },
          licenceCount: {
            ...state.licenceCount,
            success: true,
            starterLicenceError: starterLicenceError,
            error: licenceError,
            },
        });
      }

      case UPLOAD_CUSTOM_FONT:
        return {
            ...state,
            uploadFont: { uploading: true, success: false, error: null },
        };
      case UPLOADING_CUSTOM_FONT_SUCCEEDED:
        return {
            ...state,
            uploadFont: {
                uploading: false,
                success: true,
                error: null,
                data: action.payload,
            },
        };
      case UPLOADING_CUSTOM_FONT_FAILED: {
        let error = action?.payload?.errors?.[0]?.message || "Unknown error";
        return {
            ...state,
            uploadFont: { uploading: false, success: false, error },
        };
      }

      case FETCHING_ACCOUNT_INTEGRATIONS:
        return Object.assign({}, state, {
        ...state,
        integration: {
          ...state.integration,
          loading: true,
          error: null,
        },
      });

    case FETCHING_ACCOUNT_INTEGRATIONS_SUCCEEDED:
      var items = state.integration.items;

      var {
        currentPage,
        totalPages,
        recordsPerPage,
        totalRecordsCount,
        records = [],
      } = action.payload;

      if (currentPage > 0) {
        items = [...state.integration.items, ...records];
      } else {
        items = records;
      }
      return Object.assign({}, state, {
        ...state,
        integration: {
          loading: false,
          items: items,
          pagination: {
            ...state.pagination,
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount,
          },
          error: null,
        },
      });

    case FETCHING_ACCOUNT_INTEGRATIONS_FAILED:
      return Object.assign({}, state, {
        ...state,
        integration: {
          ...state.integration,
          loading: false,
          error: null,
        },
      });
    default:
      return state;
  }
}


export { accountsReducer };